import { Flex } from '@chakra-ui/react';
import { ReactNode } from 'react';

type DashedSectionProps = {
   children: ReactNode;
};

export function DashedSection({ children }: DashedSectionProps) {
   return (
      <Flex
         bgColor="white"
         justify="center"
         align="center"
         style={{
            borderStyle: 'dashed',
            borderWidth: 1.5,
            borderRadius: 'md',
            borderColor: 'gray.400',
         }}
      >
         {children}
      </Flex>
   );
}
